<template>
  <div class="app-container post-detail">
    <basic-container>
      <el-tabs v-model="activeName">
        <el-tab-pane label="基本资料" name="first">
          <el-row class="post-detail-item">
            <el-col :span="2" class="head">ID:</el-col>
            <el-col :span="16">{{postDetail.id}}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">标题:</el-col>
            <el-col :span="16">{{postDetail.title}}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">内容:</el-col>
            <el-col :span="16">
              <span v-if = "postDetail.contentType == 1">
                <div v-html="postDetail.content"></div>
              </span>
              <span v-else>{{postDetail.content}}</span>
            </el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">图片:</el-col>
            <el-col :span="16">  
              <div class="post-detail-item-picture-right">
                <span v-if="postDetail.pictures.length > 0">
                  <div v-for="pic in postDetail.pictures" :key="pic.id" 
                    class="post-detail-item-picture-right-item">
                    <img :src="pic.attachmentUrl" width="150" height="150">
                  </div>
                </span>
                <span v-else>--</span>
              </div>
            </el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">发布者:</el-col>
            <el-col :span="16">
              <a href="javascript:void(0);" @click="toMemberDetail(postDetail.postedBy.id);"
                class="post-detail-item-button">
                {{ postDetail.postedByName }}</a>
            </el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">分类:</el-col>
            <el-col :span="16">{{ postDetail.tagName }}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">圈子:</el-col>
            <el-col :span="16">
              <a href="javascript:void(0);" @click="toCircleDetail(postDetail.circleId);"
                class="post-detail-item-button">
                {{ postDetail.circleName }}</a>
            </el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">评论:</el-col>
            <el-col :span="16">
              <a href="javascript:void(0);" @click="toCommentList(id);"
                class="post-detail-item-button">
                {{ postDetail.commentCount }}</a>
            </el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">收藏:</el-col>
            <el-col :span="16">{{postDetail.favoriteCount}}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">匿名:</el-col>
            <el-col :span="16">{{postDetail.status}}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">状态:</el-col>
            <el-col :span="16">{{postDetail.isAnonymous}}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">发布时间:</el-col>
            <el-col :span="16">{{postDetail.postTime}}</el-col>
          </el-row>
        </el-tab-pane>

        <el-tab-pane label="评论详情">
          <el-table :data="commentData"
            style="width:90%" tooltip-effect="dark">
            <el-table-column align="center" prop="id" label="ID" width="100"></el-table-column>
            <el-table-column align="center" prop="commentByName" label="评论者" width="200"></el-table-column>
            <el-table-column align="center" prop="commentToName" label="评论对象" width="200"></el-table-column>
            <el-table-column align="center" prop="commentTime" label="评论时间" width="200"></el-table-column>
            <el-table-column align="center" prop="content" label="内容"></el-table-column>
          </el-table>
          <el-pagination :page-size="commentPage.pageSize"
                         :page-sizes="commentPage.pageSizes"
                         :current-page="commentPage.currentPage"
                         :total="commentPage.total"
                         :layout="commentPage.layout"
                         @current-change="commentCurrentChange"
                         @size-change="commentSizeChange">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>

    </basic-container>
  </div>
</template>

<script>
  import {getPost, fetchPostCommentList} from '@/api/post/post'

  const initDetail = vm => {
    getPost(vm.id).then(response => {
      let data = response.data
      if (response.status == 200) {
        formatPostDetail(vm.postDetail, data.data)
      } else {
        vm.$message({
          showClose: true,
          message: '无法查看该帖子详情',
          type: 'error'
        })
      }
    }).catch(error => {
      vm.$message({
        message: '获取帖子详情失败',
        type: 'error'
      })
    })
    vm.getCommentList()
  }

  const formatPostDetail = (vm, data) => {
    // 帖子详情格式化
    vm.id = data.id
    if (!data.title) vm.title = "--";
    else vm.title = data.title;
    vm.contentType = data.contentType;

    if (!data.content) vm.content = "--";
    else vm.content = data.content;
    if (!data.postedBy) vm.postedByName = "--";
    else if (!data.postedBy.name) vm.postedByName = "--";
    else { 
      vm.postedByName = data.postedBy.name;
      vm.postedBy = data.postedBy;
    }
    if (!data.tagName) vm.tagName = "--";
    else vm.tagName = data.tagName;
    if (data.circleId) vm.circleId = data.circleId
    if (!data.circleName) vm.circleName = "--";
    else vm.circleName = data.circleName;

    if (data.isActive == 0 ) vm.status = "已删除";
    else if (data.isBanned == 0) vm.status = "已上架";
    else if (data.isBanned == 1) vm.status = "已下架";
    else vm.status = "--";

    if (!data.commentCount) vm.commentCount = 0;
    else vm.commentCount = data.commentCount;
    if (!data.favoriteCount) vm.favoriteCount = 0;
    else vm.favoriteCount = data.favoriteCount;

    if (!data.postTime) vm.postTime = "--";
    else vm.postTime = data.postTime;
    if (!data.attachments || data.attachments.length === 0) vm.pictures = "";
    else vm.pictures = data.attachments;

    if (data.is_anonymous == 1 ) vm.isAnonymous = "匿名";
    else vm.isAnonymous = "--";

  }

  export default {
    data () {
      return {
        // 查看详情窗口
        activeName: "first",
        postDetail:{
          id: undefined,
          title: "",
          contentType: undefined,
          content: "",
          postedBy: undefined,
          postedByName: "",
          tagName: "",
          circleId: undefined,
          circleName: "",
          status: "",
          isActive: "",
          commentCount: 0,
          favoriteCount: 0,
          postTime: "",
          pictures: [],
        },

        // 评论详情窗口
        commentData:[],
        commentPage: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 20, // 每页显示多少条,
          pageSizes: [10, 20, 30, 40, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper"
        },
      }
    },
    watch: {
      $route () {
        this.id = this.$route.params.id
        initDetail(this)
      }
    },
    mounted () {
      this.id = this.$route.params.id
      initDetail(this)
    },
    methods: {
      getCommentList(){
        // 获取帖子的评论列表
        let params = {
          current: this.commentPage.currentPage,
          size: this.commentPage.pageSize,
          postId: this.id
        }
        fetchPostCommentList(params).then(response => {
          if (response.data.data != null) {
            this.commentData = response.data.data.records
            this.commentData.forEach(comment => {
              comment.commentByName = comment.commentBy.name
              comment.commentToName = comment.commentTo ? comment.commentTo.name : '--'
            })
            this.commentPage.total = response.data.data.total
          } else  {
            this.commentData = null
            this.commentPage.total = 0
          }
        }).catch(error => {
          this.$message({
            showClose: true,
            message: '获取该帖子的评论列表失败',
            type: 'error'
          })
        })
      },
      commentCurrentChange(val) {
        this.commentPage.currentPage = val;
        this.getCommentList();
      },
      commentSizeChange(val) {
        this.commentPage.pageSize = val;
        this.getCommentList();
      },
      toMemberDetail(postedById) {
        // 帖子详情里点击发布者姓名，链接转到该发布者的会员详情
        this.$router.push({
          path: "/upms/member/detail/" + postedById,
        })
      },
      toCircleDetail(circleId) {
        // 帖子详情里点击圈子名称，链接转到该圈子的详情页面
        this.$router.push({
          path: "/post/circle/detail/" + circleId,
        })
      },
      toCommentList(curPostId) {
        // 帖子详情里点击评论数，链接转到该帖子的评论列表
        this.$router.push({
          path: "/post/comment",
          query: {
            postId: curPostId
          }
        })
      },
    }
  }

</script>

<style lang="scss" scoped>

.post-detail {
  .post-detail-item {
    font-size: 16px;
    margin: 10px 0;
    &-button {
      margin: 0 0;
      margin-top: -5px;
      color: #409EFF;
      font-size: 15px;
      text-align: center;
      font-weight: 500;
    }
  }
  &-item-picture-right {
    font-size: 16px;
    display: table-cell;
    &-item {
      display: inline-block;
      margin-right: 15px;
      margin-top: 15px;
    }
  }
}
</style>